import { Button } from "framework7-react";
import { useToast } from "../hooks/use-toast";
import { SHARE_RESULT, shareOrCopyText } from "../utils/share";

const ShareButton = ({
  label = "Teilen",
  title = "",
  text = "",
  copiedText = "Einladung kopiert",
}) => {
  const { showInfo, showError } = useToast();

  const handleShare = async () => {
    try {
      const result = await shareOrCopyText({ title, text });
      if (result === SHARE_RESULT.copied) showInfo(copiedText);
    } catch (error) {
      showError("Kopieren nicht möglich");
    }
  };

  return (
    <Button raised large fill onClick={handleShare}>
      {label}
    </Button>
  );
};

export default ShareButton;
